import type { ProductAllowance } from '../../ChurnModal/types';

export function extractSiteIdFromProducts(products: ProductAllowance[]): string {
  const [first] = products;

  return first?.entity?.entityIdentifier;
}
